/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import { propTypes } from 'redux-form/lib/immutable';
import {
  getFlowType,
  getLTEUpgrade,
  getAPPID,
  isTablet,
  isCBandProQualifiedSession,
  enableSelfSetup,
  getSession,
  isVFEligibile,
  checkIsMidnight,
  isWHWPhase2Flag,
  isWHWP2,
  checkIsDisneyBundlePromo,
} from '../../../Helpers/index';
import { getProductRefData } from '../../../../../utils/plansReference';
import CommonSection, { filterProducts } from '../component/commonSection';
import { DISNEY_PROMO_ID, SPL_DISCOUNT_PROMO_IDS, VISION_FEATURE_CODE } from '../../Constants';

class Product extends React.PureComponent {
  renderHTMLContentDueToday = (item, plansReferenceData) => {
    const { whwPlusName, whwBasicName, extendertext } = window.vzFlags || {};
    const { planInfo, equipmentUpgradeTitle, equipmentUpgradeValue, mtnValue } = filterProducts(item, plansReferenceData, this.props.EUPDetails);
    this.planInfo = planInfo;
    let prodName = '';
    const whwProdName =
      isWHWP2() && item && item.itemType && item.itemType.includes('WHWPLUS')
        ? whwPlusName || 'Whole-Home Wi-Fi Plus'
        : whwBasicName || 'Whole-Home Wi-Fi';
    if (!isWHWP2()) {
      prodName = item && item.name;
    } else if (isWHWP2() && item && item.itemType && item.itemType.includes('WHW')) {
      prodName = whwProdName;
    } else if (this.planInfo && this.planInfo.length > 0) {
      if (this.flowType === 'LTE') {
        prodName = this.planInfo[0].minicart_Tdy_lte;
      } else if (isCBandProQualifiedSession()) {
        prodName = this?.planInfo[0]?.minicart_Tdy_5g_CBandPro ? this?.planInfo[0]?.minicart_Tdy_5g_CBandPro : this?.planInfo[0]?.minicart_Tdy_5g;
      } else {
        prodName = this.planInfo[0].minicart_Tdy_5g;
      }
    }
    const planID = prodName?.replace(/\s/g, '');
    const isTgwFlow = getSession('isTGW');
    const isWHWExtender = isWHWP2() && item?.itemType?.includes('WHW');
    return (
      <>
        {prodName && (
          <CommonSection
            leftValueText={prodName}
            rightValueText={
              <>
                {(this.flowType === 'LTE' &&
                  item.itemType === 'DEVICE' &&
                  !item.isHomePhone &&
                  item.totalAmountWithDiscount === '0.0' &&
                  item.discountApplied !== '0.0') ||
                (!isWHWP2() && item?.itemType === 'ACCESSORY' && item?.bundleProductId && isTgwFlow) ||
                (!isWHWP2() && item?.itemType === 'WHWBASIC' && item?.totalAmountWithDiscount === '0.00') ||
                isWHWExtender
                  ? 'Included'
                  : item.discountApplied && item.discountApplied !== '0.0'
                    ? item.fullPriceDiscount && item.discountApplied && item.totalAmountWithDiscount
                      ? `${item.totalAmountWithDiscount !== '0.0' ? `$${parseFloat(item.totalAmountWithDiscount).toFixed(2)}` : 'Included'}`
                      : item.totalAmountWithDiscount &&
                        item.actualAmount && (
                          <>
                            {`$${parseFloat(item.totalAmountWithDiscount).toFixed(2)}`}
                            <span className="textDecoration fontSize_2">${parseFloat(item.actualAmount).toFixed(2)}</span>
                          </>
                        )
                    : !isWHWP2() &&
                      item.discountApplied &&
                      item.discountApplied === '0.0' &&
                      item.totalAmountWithDiscount &&
                      `${item.totalAmountWithDiscount !== '0.0' ? `$${parseFloat(item.totalAmountWithDiscount).toFixed(2)}` : 'Included'}`}
              </>
            }
            id={planID}
            className="normalStyle"
            subTitle={
              <>
                {getLTEUpgrade() && equipmentUpgradeTitle !== '' ? (
                  <div>
                    <div>{equipmentUpgradeTitle}</div>
                    <div>
                      {equipmentUpgradeValue}
                      <span className="MTNValue">{mtnValue}</span>
                    </div>
                  </div>
                ) : (
                  ''
                )}

                {this.flowType === 'LTE' && item.itemType === 'DEVICE' && !item.isHomePhone
                  ? ''
                  : item.discountApplied && item.discountApplied !== '0.0' && !item.fullPriceDiscount && 'Discount Applied'}
                <div>{isWHWP2() && item?.itemType.includes('WHW') && (extendertext || 'Wi-Fi Extender')}</div>

                {item && isWHWP2() && item?.itemType.includes('WHW') && !item.bundleProductId && !item.giftCard && `Quantity: ${item?.quantity}`}
                {item && !isWHWP2() && item.itemType === 'ACCESSORY' && !item.bundleProductId && !item.giftCard && `Quantity: ${item?.quantity}`}
                {!isWHWP2() && item && item.itemType === 'WHWBASIC' && `After redemption`}
              </>
            }
          />
        )}
      </>
    );
  };

  rightVal = (item) => {
    const isDiscountIncluded = item?.itemType?.toLowerCase()?.includes('discount');
    const isMidnight = checkIsMidnight();
    const promoApplied = item?.discountsAndPromotions?.promos || [];

    const specialDiscountPromos = promoApplied?.filter((appliedDiscount) => SPL_DISCOUNT_PROMO_IDS.includes(appliedDiscount?.id));
    const isHavingSpecialDiscount = specialDiscountPromos?.length > 0;
    let finalPrice = 0;
    if (isHavingSpecialDiscount) {
      finalPrice = parseFloat(item?.discountsAndPromotions?.actualPrice) - parseFloat(specialDiscountPromos[0]?.amountOff);
    }
    return item.isAccountDiscount && isDiscountIncluded ? (
      `-$${parseFloat(item.totalAmountWithDiscount).toFixed(2)}`
    ) : isMidnight && item.itemType === 'PERK' ? (
      <>
        {parseFloat(item?.actualAmount)?.toFixed(2) !== parseFloat(item?.totalAmountWithDiscount)?.toFixed(2) && (
          <span>
            <span className="actualPriceStrikeThrough">${parseFloat(item?.actualAmount)?.toFixed(2)}</span>&nbsp;
          </span>
        )}
        $
        {checkIsDisneyBundlePromo() && item?.productId === VISION_FEATURE_CODE && item?.discountsAndPromotions
          ? isHavingSpecialDiscount
            ? parseFloat(finalPrice)?.toFixed(2)
            : parseFloat(item?.discountsAndPromotions?.actualPrice)?.toFixed(2)
          : parseFloat(item?.totalAmountWithDiscount)?.toFixed(2)}
      </>
    ) : item.itemType === 'DISCOUNT' &&
      item.name &&
      (item?.name?.startsWith('Auto') ||
        item?.name?.includes('Loyalty') ||
        item?.name?.includes('Employee') ||
        item?.name?.includes('Mobile + Home Discount') ||
        item?.isCouponDiscount ||
        item?.name?.includes('Unlimited')) &&
      item.totalAmountWithDiscount ? (
      'Included'
    ) : (
      `${
        (item.totalAmountWithDiscount && item.totalAmountWithDiscount === '0.0') || (item?.isAccountDiscount === false && isDiscountIncluded)
          ? 'Included'
          : `$${parseFloat(item.totalAmountWithDiscount).toFixed(2)}`
      }`
    );
  };

  // WHWDueMontnlySubTitle = (item) => {
  //   if (isWHWP2() && item.itemType.toLowerCase().includes('whwplus')) {
  //     return (
  //       <>
  //         <> {isWHWP2() && 'Plus taxes and surcharges. Billed after shipment.'}</>
  //         <div>{(isWHWP2() && item.itemType.toLowerCase().includes('whwplus') && 'Wi-Fi Extender') || ''}</div>
  //         {item &&
  //           isWHWP2() &&
  //           item.itemType.toLowerCase().includes('whw') &&
  //           !item.bundleProductId &&
  //           !item.giftCard &&
  //           `Quantity: ${item.quantity}`}
  //       </>
  //     );
  //   }
  // };

  MonthlyPaymentssubTitleVal = (item) => {
    let showPayment = false;
    const LoanTermLTE = getSession('LoanTermLTE');
    if (LoanTermLTE === '24') {
      showPayment = true;
    }
    return (
      item.itemType &&
      item.itemType === 'DEVICE' &&
      this.flowType === 'LTE' &&
      !item.isHomePhone &&
      showPayment &&
      `${this.planInfo && this.planInfo.length > 0 && this.planInfo[0].dueMonthlyText ? this.planInfo[0].dueMonthlyText : '24 Monthly Payments'}`
    );
  };

  subTitleVal = (item, showNBSDisclaimer) => {
    this.MonthlyPaymentssubTitleVal(item);

    if (isWHWP2() && item?.itemType.includes('WHWPLUS')) {
      return (
        <>
          <> {isWHWP2() && 'Plus taxes and surcharges. Billed after shipment.'}</>
          <div>{(isWHWP2() && item?.itemType.includes('WHWPLUS') && 'Wi-Fi Extender') || ''}</div>
          {item && isWHWP2() && item?.itemType.includes('WHW') && !item.bundleProductId && !item.giftCard && `Quantity: ${item?.quantity}`}
        </>
      );
    }

    return !showNBSDisclaimer ? this.afterInstallText(item) : '';
  };

  afterInstallText = (item) => {
    let val;
    if (item && item.itemType && item.itemType === 'PLAN' && item.isHomePhone) {
      val = `${this.planInfo && this.planInfo.length > 0 && this.planInfo[0].dueMonthlyText ? this.planInfo[0].dueMonthlyText : 'After installation*'}`;
    } else if (item && item.itemType && item.itemType === 'PROTECTION') {
      val = `${
        this.planInfo && this.planInfo.length > 0 && this.planInfo[0].activateText
          ? `${this.planInfo[0].activateText} ${this.props?.taxFeeText || ''}`
          : `After Activation ${this.props?.taxFeeText || ''}`
      }`;
    } else if (item && item.itemType && item.itemType === 'SUBSCRIPTION') {
      val = `${this.planInfo && this.planInfo.length > 0 && this.planInfo[0].activateText ? `${this.planInfo[0].activateText}` : 'After Activation'}`;
    }
    return val;
  };

  renderHTMLContentDueMonthly = (item, plansReferenceData, flowType) => {
    this.planInfo = getProductRefData(item.sorId, item.productId, plansReferenceData);
    if (item?.name?.startsWith('Auto') && item.itemType === 'DISCOUNT' && flowType === 'LTE') {
      this.planInfo = getProductRefData('LTEAUTOPAY', '', plansReferenceData);
    } else if (item?.name?.includes('Loyalty') && item.itemType === 'DISCOUNT' && flowType === 'LTE') {
      this.planInfo = getProductRefData('LTELOYALTY', '', plansReferenceData);
    }
    const { whwPlusName, whwBasicName } = window.vzFlags || {};
    let prodName;
    const whwProdName =
      isWHWP2() && item && item.itemType && item.itemType.includes('WHWPLUS')
        ? whwPlusName || 'Whole-Home Wi-Fi Plus'
        : whwBasicName || 'Whole-Home Wi-Fi';
    if (item.name && item.itemType !== 'SUBSCRIPTION') {
      prodName = isWHWP2() && item && item.itemType && item.itemType.includes('WHW') ? whwProdName : item.name;
    } else if (this.planInfo && this.planInfo.length > 0) {
      if (this.flowType === 'LTE') {
        prodName = this.planInfo[0].minicart_Mly_lte;
      } else if (isCBandProQualifiedSession()) {
        prodName = this?.planInfo[0]?.minicart_Mly_5g_CBandPro ? this?.planInfo[0]?.minicart_Mly_5g_CBandPro : this?.planInfo[0].minicart_Mly_5g;
      } else {
        prodName = this.planInfo[0].minicart_Mly_5g;
      }
    }

    const showNBSDisclaimer = getAPPID() === 'AAL' && enableSelfSetup();
    this.isTablet = isTablet();
    const planID = prodName?.replace(/\s/g, '');
    const isMidnight = checkIsMidnight();
    const promoApplied = item?.discountsAndPromotions?.promos || [];

    return (
      <>
        {showNBSDisclaimer ? (
          item &&
          ((item.itemType === 'PLAN' && !item.isHomePhone) ||
            item.itemType === 'DISCOUNT' ||
            (isMidnight && item.itemType === 'PERK') ||
            (isWHWPhase2Flag() && item.itemType === 'WHWPLUS')) &&
          (item.itemType !== 'PROTECTION' || item.itemType !== 'SUBSCRIPTION') && (
            <>
              <CommonSection
                leftValueText={prodName}
                rightValueText={this.rightVal(item)}
                subTitle={this.subTitleVal(item, showNBSDisclaimer)}
                id={planID}
                className="normalStyle"
              />
              {checkIsDisneyBundlePromo() &&
                promoApplied.map((promo) => {
                  const isDisneyPromo = promo?.id === DISNEY_PROMO_ID;
                  return (
                    <>
                      {isDisneyPromo ? (
                        <CommonSection
                          leftValueText={promo?.description}
                          rightValueText={`-$${parseFloat(promo?.amountOff).toFixed(2)}`}
                          id="Promo-Offer"
                          subTitle={this.props.disneyPromoHelperText}
                          promoDiscount
                        />
                      ) : null}
                    </>
                  );
                })}
            </>
          )
        ) : (
          <>
            <CommonSection
              leftValueText={prodName}
              rightValueText={this.rightVal(item)}
              subTitle={this.subTitleVal(item, showNBSDisclaimer)}
              id="DueMonthly TaxInfo"
              className="normalStyle"
            />
            {checkIsDisneyBundlePromo() &&
              promoApplied.map((promo) => {
                const isDisneyPromo = promo.id === DISNEY_PROMO_ID;
                return (
                  <>
                    {isDisneyPromo ? (
                      <CommonSection
                        leftValueText={promo?.description}
                        rightValueText={`-$${parseFloat(promo?.amountOff).toFixed(2)}`}
                        id="Promo-Offer"
                        subTitle={this.props.disneyPromoHelperText}
                        promoDiscount
                      />
                    ) : null}
                  </>
                );
              })}
          </>
        )}
      </>
    );
  };

  render() {
    const { dueTodayList = [], dueMonthlyList = [], showDueToday, showDueMonthly, plansReferenceData } = this.props;

    this.flowType = getFlowType();
    return (
      <React.Fragment>
        {showDueToday && dueTodayList?.length && dueTodayList.map((item) => this.renderHTMLContentDueToday(item, plansReferenceData, this.flowType))}

        {showDueMonthly &&
          dueMonthlyList?.length > 0 &&
          dueMonthlyList.map((item) =>
            isVFEligibile()
              ? item?.name?.indexOf('Verizon Forward') === -1 && this.renderHTMLContentDueMonthly(item, plansReferenceData, this.flowType)
              : this.renderHTMLContentDueMonthly(item, plansReferenceData, this.flowType),
          )}
      </React.Fragment>
    );
  }
}
Product.propTypes = {
  dueTodayList: PropTypes.array,
  dueMonthlyList: PropTypes.array,
  showDueToday: PropTypes.bool,
  showDueMonthly: PropTypes.bool,
  plansReferenceData: PropTypes.string,
  EUPDetails: PropTypes.object,
  taxFeeText: PropTypes.string,
  disneyPromoHelperText: propTypes.string,
};
export default Product;
